import { imgPrefix } from '@/utils/imgPrefix';
import { Button } from 'darrius';
import Image from 'next/image';
import styles from '../FeedbackValidation.module.scss';
import Link from 'next/link';

export default function FeedbackValidationRejectedDocument() {
  return (
    <div className={`${styles['wrapper-feedback']}`}>
      <p className={`${styles['main-title']}`}>
        Validação de Documento Digital
      </p>

      <div className={`${styles['feedback']}`}>
        <Image
          src={imgPrefix('/images/idwall/document-validation-error.svg')}
          alt="Validação de documentos em andamento"
          width={164}
          height={192}
          quality={100}
        />

        <p className={`${styles['feedback-title']}`}>
          Houve um problema ao validar seu documento
        </p>

        <span>Não conseguimos prosseguir no momento com a sua validação.</span>

        <Link href="https://www.getninjas.com.br/central-de-ajuda/chatbot?eusou=Profissional">
          <Button.Root
            type="button"
            variation="primary"
            className={`${styles['feedback-button']}`}
          >
            Falar com suporte
          </Button.Root>
        </Link>
      </div>
    </div>
  );
}
